<template>
  <div>
    <div class="container food-detail">
      <div class="card">
        <img
          :src="foodDetailData.imgUrl"
          class="card-img-top"
        />
        <div class="card-body">
          <h1>{{foodDetailData.name}}</h1>
          <h4>{{foodDetailData.price}}</h4>
          <p id="description-detail" class="card-text">
            {{foodDetailData.description}}
          </p>
          <button
            type="button"
            class="btn btn-secondary detail-food"
            v-on:click="backButton"
          >
            Back
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Fooddetail",
  props: ["foodDetailData"],
  methods: {
    backButton() {
      this.$emit("backFromDetail");
    },
  },
};
</script>

<style>
</style>